import React from "react";
import Marquee from "react-fast-marquee";
import { useLanguage } from "../context/LanguageContext";

const TrustStrip = () => {
  const { t } = useLanguage();
  const items = [
    t.trust,
    "Ericeira · Portugal",
    "Independent · Local · Real",
    t.trust,
    "Ericeira · Portugal",
    "Independent · Local · Real",
  ];

  return (
    <section
      className="bg-[#DDE5DD] border-y border-[rgba(117,148,122,0.2)]"
      data-testid="trust-strip"
    >
      <Marquee speed={34} gradient={false} pauseOnHover>
        <div className="flex items-center gap-16 py-5 pr-16">
          {items.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-16 text-[#202C21] font-heading text-sm tracking-tight"
            >
              <span className="opacity-80">{item}</span>
              <span className="w-1.5 h-1.5 rounded-full bg-[#75947A]" />
            </div>
          ))}
        </div>
      </Marquee>
    </section>
  );
};

export default TrustStrip;
